import { useSearchParams } from 'react-router-dom'

const useBetterSearchParams = initialSearchParams => {
    
    const [searchParams, setSearchParams] = useSearchParams(initialSearchParams)
    
    const updateSearchParams = updates => setSearchParams(prev => {
        
        Object.entries(updates).forEach(([key, value]) => {
            
            if (value === null || value === undefined)
                prev.delete(key)
            else
                prev.set(key, String(value))
            
        })
        
        return prev
        
    })
    
    return {
        searchParams,
        setSearchParams,
        updateSearchParams,
    }
    
}

export default useBetterSearchParams
